<template>
	<div>
		<div v-if="Auth.checkPermission( 'LOGGED_IN' )">
			<router-link to="/signout" class="d-block">Sign out</router-link>
			<router-link to="/user/profile" class="d-block">Account Settings</router-link>
			<router-link to="/quotes" class="d-block">Quotes</router-link>
		</div>
		<div v-if="Auth.checkPermission( 'LOGGED_IN' )">
			<a class="d-md-block">&nbsp;</a>
			<router-link to="/" class="d-block">My Dashboard</router-link>
			<router-link
				to="/claims"
				class="d-block"
				v-if="Auth.checkPermission( 'REPORT_CLAIM' )"
			>Claims / Incident</router-link>
		</div>
		<div v-if="Auth.checkPermission( 'LOGGED_IN' )">
			<a class="d-md-block">&nbsp;</a>
			<router-link to="/policy" class="d-block" v-if="Auth.checkPermission( 'VIEW_COI' )">Policy Docs</router-link>
			<router-link
				to="/payment"
				class="d-block"
				v-if="Auth.checkPermission( 'BILL_PAY' )"
			>Online Payments</router-link>
		</div>
	</div>
</template>

<script>
import Auth from '@/services/Auth';

export default {
	data() {
		return {
			Auth,
		};
	},
};
</script>